/* eslint-disable import/no-anonymous-default-export */
export default(active=[],action)=>{
    switch (action.type) {
        case 'GET_ALL_EXHAUSTED_ASSETS':
            return action.payload
        default:
            return active;
    }
}